<template>

  <form class="yoomoney-payment-form" action="https://yookassa.ru/integration/simplepay/payment" method="post" accept-charset="utf-8">


    <input v-if="email" name="cps_email" placeholder="Email" type="hidden" :value="email"/>
    <input v-if="phone" name="cps_phone" placeholder="Телефон" type="hidden" :value="phone"/>
    <input v-if="fio" name="custName" placeholder="ФИО" type="hidden" :value="fio"/>
    <input v-if="comment" name="orderDetails" placeholder="Комментарий" type="hidden" :value="comment"/>
    <input v-if="info" name="customerNumber" type="hidden" :value="info"/>

    <div class="ym-payment-btn-block">
      <div class="ym-input-icon-rub ym-display-none">
        <input name="sum" placeholder="0.00" class="ym-input ym-sum-input ym-required-input" type="hidden"  step="any" :value="price">
      </div>
      <v-btn type="submit" block :disabled="disabled" :data-text="btnText" class="v-btn call-btn-3 ym-btn-pay ym-result-price"><span class="ym-text-crop">{{ btnText }}</span>  </v-btn>
    </div>
    <input name="shopId" type="hidden" value="836525"></form>
</template>

<script>

export default {
  name: "ycassa",
  props: ["btnText", "disabled", "price", "email", "phone", "fio", "comment", "info"],
  data: () => ({}),
};
</script>

<style lang="scss">

.yoomoney-payment-form{
  .ym-payment-btn-block {

    .ym-btn-pay{
      text-transform: uppercase !important;
      max-width: none !important;
    }
  }
}

</style>